import * as React from 'react';

type ItemProps = {
  paragraph: string;
  shouldParser?: boolean;
};

const Item: React.FC<React.PropsWithChildren<ItemProps>> = ({
  paragraph,
  shouldParser,
}) => {
  return (
    <li>
      {shouldParser ? (
        <span dangerouslySetInnerHTML={{ __html: paragraph }} />
      ) : (
        <span>{paragraph}</span>
      )}
    </li>
  );
};

export default Item;
